import { IFilter } from '../../types/filters';
import { ExcludeWordsContainer } from '../../containers/advancedFilters/ExcludeWordsContainer';

export const excludeWords: IFilter = {
  component: ExcludeWordsContainer,
};
